import keyMirror from "keymirror";

export const DataTypes = keyMirror({
    ACCOUNT_PASSWORD: null,
    ACCOUNT_PROFILE: null,
    ACCOUNT_SECURITY: null,
    ACCOUNT_SUBSCRIPTIONS: null,
    APPLICATIONS: null,
    CMS_CONTENT: null,
    CONTACTS: null,
    JP_JOBPLAN: null,
    JP_ACTIVITY: null,
    JP_ACTIVITY_CATEGORY: null,
    JP_ACTIVITY_TYPE: null,
    JP_ACTIVITY_OBJECTIVE: null,
    JP_LOCATION: null,
    ACTIVITIES: null,
    ACTIVITY: null,
    CATEGORIES: null,
    NOTES: null,
    NOTE: null,
    PDPS: null,
    PDP: null,
    DEVELOPMENT_NEEDS: null,
    DEVELOPMENT_NEED: null,
    QUALIFICATIONS: null,
    QUALIFICATION: null,
    RESOURCES: null,
    RESOURCE: null,
    RMS_APPRAISEES: null,
    RMS_APPRAISEE: null,
    RMS_APPRAISERS: null,
    RMS_APPRAISALS: null,
    RMS_APPRAISAL: null,
    RMS_APPRAISAL_FORM: null,
    RMS_APPRAISAL_FORM_ELEMENT: null,
    RMS_SURVEY: null,
    RS_ROSTER: null,
    SCOPE_OF_WORK: null,
    MFA_METHODS: null,
    MSF_SURVEY: null,
    MSF_SURVEY_TYPE: null,
    MSF_SURVEY_REPORT: null,
    MSF_QUESTIONNAIRE: null,
    MSF_FACILITATORS: null,
    MSF_RECIPIENTS: null,
    MESSAGES: null,
    MESSAGE: null,
    NOTIFICATIONS: null,
    NOTIFICATION: null,
    TASKS: null,
    TERMS: null,
    TERM: null,
    TMS_ACCOMPLISHMENTS: null,
    TMS_CATEGORY: null,
    TMS_COURSES: null,
    TMS_COURSE: null,
    TMS_ENROLMENT: null,
    TMS_EVENT: null,
    TMS_EVENTS: null,
    TMS_EVENT_BOOKING: null,
    TMS_LAUNCH_URL: null,
    TMS_LIBRARY: null,
    TMS_MODULE: null,
    TMS_MODULE_ENROLMENT: null,
    USER_INFO: null,
});

export const ActionTypes = {
    GET_USER_INFO: `GET_${DataTypes.USER_INFO}`,
    GET_APPLICATIONS: `GET_${DataTypes.APPLICATIONS}`,
    ACTIVATE_APPLICATION: 'ACTIVATE_APPLICATION',

    GET_RMS_APPRAISEES_REQUEST: `GET_${DataTypes.RMS_APPRAISEES}_REQUEST`,
    GET_RMS_APPRAISEES_SUCCESS: `GET_${DataTypes.RMS_APPRAISEES}_SUCCESS`,
    GET_RMS_APPRAISEES_FAILURE: `GET_${DataTypes.RMS_APPRAISEES}_FAILURE`,

    GET_RMS_APPRAISEE_REQUEST: `GET_${DataTypes.RMS_APPRAISEE}_REQUEST`,
    GET_RMS_APPRAISEE_SUCCESS: `GET_${DataTypes.RMS_APPRAISEE}_SUCCESS`,
    GET_RMS_APPRAISEE_FAILURE: `GET_${DataTypes.RMS_APPRAISEE}_FAILURE`,

    GET_RMS_APPRAISERS_REQUEST: `GET_${DataTypes.RMS_APPRAISERS}_REQUEST`,
    GET_RMS_APPRAISERS_SUCCESS: `GET_${DataTypes.RMS_APPRAISERS}_SUCCESS`,
    GET_RMS_APPRAISERS_FAILURE: `GET_${DataTypes.RMS_APPRAISERS}_FAILURE`,
    GET_RMS_APPRAISALS_REQUEST: `GET_${DataTypes.RMS_APPRAISALS}_REQUEST`,
    GET_RMS_APPRAISALS_SUCCESS: `GET_${DataTypes.RMS_APPRAISALS}_SUCCESS`,
    GET_RMS_APPRAISALS_FAILURE: `GET_${DataTypes.RMS_APPRAISALS}_FAILURE`,
    GET_RMS_APPRAISAL_DETAILS_REQUEST: `GET_${DataTypes.RMS_APPRAISAL}_REQUEST`,
    GET_RMS_APPRAISAL_DETAILS_SUCCESS: `GET_${DataTypes.RMS_APPRAISAL}_SUCCESS`,
    GET_RMS_APPRAISAL_DETAILS_FAILURE: `GET_${DataTypes.RMS_APPRAISAL}_FAILURE`,

    ADD_RMS_APPRAISAL_INIT_REQUEST: `ADD_${DataTypes.RMS_APPRAISAL}_REQUEST`,
    ADD_RMS_APPRAISAL_INIT_SUCCESS: `ADD_${DataTypes.RMS_APPRAISAL}_SUCCESS`,
    ADD_RMS_APPRAISAL_INIT_FAILURE: `ADD_${DataTypes.RMS_APPRAISAL}_FAILURE`,

    ADD_RMS_APPRAISAL_REQUEST: `ADD_${DataTypes.RMS_APPRAISAL}_REQUEST`,
    ADD_RMS_APPRAISAL_SUCCESS: `ADD_${DataTypes.RMS_APPRAISAL}_SUCCESS`,
    ADD_RMS_APPRAISAL_FAILURE: `ADD_${DataTypes.RMS_APPRAISAL}_FAILURE`,
    UPDATE_RMS_APPRAISAL_REQUEST: `UPDATE_${DataTypes.RMS_APPRAISAL}_REQUEST`,
    UPDATE_RMS_APPRAISAL_SUCCESS: `UPDATE_${DataTypes.RMS_APPRAISAL}_SUCCESS`,
    UPDATE_RMS_APPRAISAL_FAILURE: `UPDATE_${DataTypes.RMS_APPRAISAL}_FAILURE`,
    ADD_RMS_APPRAISAL_FORM_REQUEST: `UPDATE_${DataTypes.RMS_APPRAISAL_FORM}_REQUEST`,
    ADD_RMS_APPRAISAL_FORM_SUCCESS: `UPDATE_${DataTypes.RMS_APPRAISAL_FORM}_SUCCESS`,
    ADD_RMS_APPRAISAL_FORM_FAILURE: `UPDATE_${DataTypes.RMS_APPRAISAL_FORM}_FAILURE`,
    UPDATE_RMS_APPRAISAL_FORM_REQUEST: `UPDATE_${DataTypes.RMS_APPRAISAL_FORM}_REQUEST`,
    UPDATE_RMS_APPRAISAL_FORM_SUCCESS: `UPDATE_${DataTypes.RMS_APPRAISAL_FORM}_SUCCESS`,
    UPDATE_RMS_APPRAISAL_FORM_FAILURE: `UPDATE_${DataTypes.RMS_APPRAISAL_FORM}_FAILURE`,
    UPDATE_RMS_APPRAISAL_FORM_ELEMENT_REQUEST: `UPDATE_${DataTypes.RMS_APPRAISAL_FORM_ELEMENT}_REQUEST`,
    UPDATE_RMS_APPRAISAL_FORM_ELEMENT_SUCCESS: `UPDATE_${DataTypes.RMS_APPRAISAL_FORM_ELEMENT}_SUCCESS`,
    UPDATE_RMS_APPRAISAL_FORM_ELEMENT_FAILURE: `UPDATE_${DataTypes.RMS_APPRAISAL_FORM_ELEMENT}_FAILURE`,

    UPDATE_RMS_SURVEY_REQUEST: `UPDATE_${DataTypes.RMS_SURVEY}_REQUEST`,
    UPDATE_RMS_SURVEY_SUCCESS: `UPDATE_${DataTypes.RMS_SURVEY}_SUCCESS`,
    UPDATE_RMS_SURVEY_FAILURE: `UPDATE_${DataTypes.RMS_SURVEY}_FAILURE`,

    GET_JP_JOBPLAN_LIST_REQUEST: `GET_${DataTypes.JP_JOBPLAN}_LIST_REQUEST`,
    GET_JP_JOBPLAN_LIST_SUCCESS: `GET_${DataTypes.JP_JOBPLAN}_LIST_SUCCESS`,
    GET_JP_JOBPLAN_LIST_FAILURE: `GET_${DataTypes.JP_JOBPLAN}_LIST_FAILURE`,
    GET_JP_JOBPLAN_REQUEST: `GET_${DataTypes.JP_JOBPLAN}_REQUEST`,
    GET_JP_JOBPLAN_SUCCESS: `GET_${DataTypes.JP_JOBPLAN}_SUCCESS`,
    GET_JP_JOBPLAN_FAILURE: `GET_${DataTypes.JP_JOBPLAN}_FAILURE`,
    DELETE_JP_JOBPLAN_REQUEST: `DELETE_${DataTypes.JP_JOBPLAN}_REQUEST`,
    DELETE_JP_JOBPLAN_SUCCESS: `DELETE_${DataTypes.JP_JOBPLAN}_SUCCESS`,
    DELETE_JP_JOBPLAN_FAILURE: `DELETE_${DataTypes.JP_JOBPLAN}_FAILURE`,

    ADD_JP_ACTIVITY_REQUEST: `ADD_${DataTypes.JP_ACTIVITY}_REQUEST`,
    ADD_JP_ACTIVITY_SUCCESS: `ADD_${DataTypes.JP_ACTIVITY}_SUCCESS`,
    ADD_JP_ACTIVITY_FAILURE: `ADD_${DataTypes.JP_ACTIVITY}_FAILURE`,
    UPDATE_JP_ACTIVITY_REQUEST: `UPDATE_${DataTypes.JP_ACTIVITY}_REQUEST`,
    UPDATE_JP_ACTIVITY_SUCCESS: `UPDATE_${DataTypes.JP_ACTIVITY}_SUCCESS`,
    UPDATE_JP_ACTIVITY_FAILURE: `UPDATE_${DataTypes.JP_ACTIVITY}_FAILURE`,
    DELETE_JP_ACTIVITY_REQUEST: `DELETE_${DataTypes.JP_ACTIVITY}_REQUEST`,
    DELETE_JP_ACTIVITY_SUCCESS: `DELETE_${DataTypes.JP_ACTIVITY}_SUCCESS`,
    DELETE_JP_ACTIVITY_FAILURE: `DELETE_${DataTypes.JP_ACTIVITY}_FAILURE`,

    GET_JP_ACTIVITY_CATEGORY_LIST_REQUEST: `GET_${DataTypes.JP_ACTIVITY_CATEGORY}_LIST_REQUEST`,
    GET_JP_ACTIVITY_CATEGORY_LIST_SUCCESS: `GET_${DataTypes.JP_ACTIVITY_CATEGORY}_LIST_SUCCESS`,
    GET_JP_ACTIVITY_CATEGORY_LIST_FAILURE: `GET_${DataTypes.JP_ACTIVITY_CATEGORY}_LIST_FAILURE`,

    GET_JP_ACTIVITY_TYPE_LIST_REQUEST: `GET_${DataTypes.JP_ACTIVITY_TYPE}_LIST_REQUEST`,
    GET_JP_ACTIVITY_TYPE_LIST_SUCCESS: `GET_${DataTypes.JP_ACTIVITY_TYPE}_LIST_SUCCESS`,
    GET_JP_ACTIVITY_TYPE_LIST_FAILURE: `GET_${DataTypes.JP_ACTIVITY_TYPE}_LIST_FAILURE`,

    GET_JP_ACTIVITY_OBJECTIVE_LIST_REQUEST: `GET_${DataTypes.JP_ACTIVITY_OBJECTIVE}_LIST_REQUEST`,
    GET_JP_ACTIVITY_OBJECTIVE_LIST_SUCCESS: `GET_${DataTypes.JP_ACTIVITY_OBJECTIVE}_LIST_SUCCESS`,
    GET_JP_ACTIVITY_OBJECTIVE_LIST_FAILURE: `GET_${DataTypes.JP_ACTIVITY_OBJECTIVE}_LIST_FAILURE`,

    GET_JP_LOCATION_LIST_REQUEST: `GET_${DataTypes.JP_LOCATION}_LIST_REQUEST`,
    GET_JP_LOCATION_LIST_SUCCESS: `GET_${DataTypes.JP_LOCATION}_LIST_SUCCESS`,
    GET_JP_LOCATION_LIST_FAILURE: `GET_${DataTypes.JP_LOCATION}_LIST_FAILURE`,

    GET_DEVELOPMENT_NEEDS_REQUEST: `GET_${DataTypes.DEVELOPMENT_NEEDS}_REQUEST`,
    GET_DEVELOPMENT_NEEDS_SUCCESS: `GET_${DataTypes.DEVELOPMENT_NEEDS}_SUCCESS`,
    GET_DEVELOPMENT_NEEDS_FAILURE: `GET_${DataTypes.DEVELOPMENT_NEEDS}_FAILURE`,
    GET_DEVELOPMENT_NEED_REQUEST: `GET_${DataTypes.DEVELOPMENT_NEED}_REQUEST`,
    GET_DEVELOPMENT_NEED_SUCCESS: `GET_${DataTypes.DEVELOPMENT_NEED}_SUCCESS`,
    GET_DEVELOPMENT_NEED_FAILURE: `GET_${DataTypes.DEVELOPMENT_NEED}_FAILURE`,
    ADD_DEVELOPMENT_NEED_REQUEST: `ADD_${DataTypes.DEVELOPMENT_NEED}_REQUEST`,
    ADD_DEVELOPMENT_NEED_SUCCESS: `ADD_${DataTypes.DEVELOPMENT_NEED}_SUCCESS`,
    ADD_DEVELOPMENT_NEED_FAILURE: `ADD_${DataTypes.DEVELOPMENT_NEED}_FAILURE`,
    UPDATE_DEVELOPMENT_NEED_REQUEST: `UPDATE_${DataTypes.DEVELOPMENT_NEED}_REQUEST`,
    UPDATE_DEVELOPMENT_NEED_SUCCESS: `UPDATE_${DataTypes.DEVELOPMENT_NEED}_SUCCESS`,
    UPDATE_DEVELOPMENT_NEED_FAILURE: `UPDATE_${DataTypes.DEVELOPMENT_NEED}_FAILURE`,
    DELETE_DEVELOPMENT_NEED_REQUEST: `DELETE_${DataTypes.DEVELOPMENT_NEED}_REQUEST`,
    DELETE_DEVELOPMENT_NEED_SUCCESS: `DELETE_${DataTypes.DEVELOPMENT_NEED}_SUCCESS`,
    DELETE_DEVELOPMENT_NEED_FAILURE: `DELETE_${DataTypes.DEVELOPMENT_NEED}_FAILURE`,

    GET_SCOPE_OF_WORK_REQUEST: `GET_${DataTypes.SCOPE_OF_WORK}_REQUEST`,
    GET_SCOPE_OF_WORK_SUCCESS: `GET_${DataTypes.SCOPE_OF_WORK}_SUCCESS`,
    GET_SCOPE_OF_WORK_FAILURE: `GET_${DataTypes.SCOPE_OF_WORK}_FAILURE`,
    ADD_SCOPE_OF_WORK_REQUEST: `ADD_${DataTypes.SCOPE_OF_WORK}_REQUEST`,
    ADD_SCOPE_OF_WORK_SUCCESS: `ADD_${DataTypes.SCOPE_OF_WORK}_SUCCESS`,
    ADD_SCOPE_OF_WORK_FAILURE: `ADD_${DataTypes.SCOPE_OF_WORK}_FAILURE`,
    UPDATE_SCOPE_OF_WORK_REQUEST: `UPDATE_${DataTypes.SCOPE_OF_WORK}_REQUEST`,
    UPDATE_SCOPE_OF_WORK_SUCCESS: `UPDATE_${DataTypes.SCOPE_OF_WORK}_SUCCESS`,
    UPDATE_SCOPE_OF_WORK_FAILURE: `UPDATE_${DataTypes.SCOPE_OF_WORK}_FAILURE`,
    DELETE_SCOPE_OF_WORK_REQUEST: `DELETE_${DataTypes.SCOPE_OF_WORK}_REQUEST`,
    DELETE_SCOPE_OF_WORK_SUCCESS: `DELETE_${DataTypes.SCOPE_OF_WORK}_SUCCESS`,
    DELETE_SCOPE_OF_WORK_FAILURE: `DELETE_${DataTypes.SCOPE_OF_WORK}_FAILURE`,

    GET_MFA_METHODS_REQUEST: `GET_${DataTypes.MFA_METHODS}_REQUEST`,
    GET_MFA_METHODS_SUCCESS: `GET_${DataTypes.MFA_METHODS}_SUCCESS`,
    GET_MFA_METHODS_FAILURE: `GET_${DataTypes.MFA_METHODS}_FAILURE`,

    GET_MSF_SURVEY_LIST_REQUEST: `GET_${DataTypes.MSF_SURVEY}_LIST_REQUEST`,
    GET_MSF_SURVEY_LIST_SUCCESS: `GET_${DataTypes.MSF_SURVEY}_LIST_SUCCESS`,
    GET_MSF_SURVEY_LIST_FAILURE: `GET_${DataTypes.MSF_SURVEY}_LIST_FAILURE`,
    GET_MSF_SURVEY_REQUEST: `GET_${DataTypes.MSF_SURVEY}_REQUEST`,
    GET_MSF_SURVEY_SUCCESS: `GET_${DataTypes.MSF_SURVEY}_SUCCESS`,
    GET_MSF_SURVEY_FAILURE: `GET_${DataTypes.MSF_SURVEY}_FAILURE`,
    ADD_MSF_SURVEY_REQUEST: `ADD_${DataTypes.MSF_SURVEY}_REQUEST`,
    ADD_MSF_SURVEY_SUCCESS: `ADD_${DataTypes.MSF_SURVEY}_SUCCESS`,
    ADD_MSF_SURVEY_FAILURE: `ADD_${DataTypes.MSF_SURVEY}_FAILURE`,
    UPDATE_MSF_SURVEY_REQUEST: `UPDATE_${DataTypes.MSF_SURVEY}_REQUEST`,
    UPDATE_MSF_SURVEY_SUCCESS: `UPDATE_${DataTypes.MSF_SURVEY}_SUCCESS`,
    UPDATE_MSF_SURVEY_FAILURE: `UPDATE_${DataTypes.MSF_SURVEY}_FAILURE`,
    DELETE_MSF_SURVEY_REQUEST: `DELETE_${DataTypes.MSF_SURVEY}_REQUEST`,
    DELETE_MSF_SURVEY_SUCCESS: `DELETE_${DataTypes.MSF_SURVEY}_SUCCESS`,
    DELETE_MSF_SURVEY_FAILURE: `DELETE_${DataTypes.MSF_SURVEY}_FAILURE`,
    APPLY_MSF_SURVEY_ACTION_REQUEST: `APPLY_${DataTypes.MSF_SURVEY}_ACTION_REQUEST`,
    APPLY_MSF_SURVEY_ACTION_SUCCESS: `APPLY_${DataTypes.MSF_SURVEY}_ACTION_SUCCESS`,
    APPLY_MSF_SURVEY_ACTION_FAILURE: `APPLY_${DataTypes.MSF_SURVEY}_ACTION_FAILURE`,
    GET_MSF_SURVEY_TYPES_REQUEST: `GET_${DataTypes.MSF_SURVEY_TYPE}_REQUEST`,
    GET_MSF_SURVEY_TYPES_SUCCESS: `GET_${DataTypes.MSF_SURVEY_TYPE}_SUCCESS`,
    GET_MSF_SURVEY_TYPES_FAILURE: `GET_${DataTypes.MSF_SURVEY_TYPE}_FAILURE`,
    GET_MSF_SURVEY_REPORT_REQUEST: `GET_${DataTypes.MSF_SURVEY_REPORT}_REQUEST`,
    GET_MSF_SURVEY_REPORT_SUCCESS: `GET_${DataTypes.MSF_SURVEY_REPORT}_SUCCESS`,
    GET_MSF_SURVEY_REPORT_FAILURE: `GET_${DataTypes.MSF_SURVEY_REPORT}_FAILURE`,
    GET_MSF_QUESTIONNAIRE_LIST_REQUEST: `GET_${DataTypes.MSF_QUESTIONNAIRE}_LIST_REQUEST`,
    GET_MSF_QUESTIONNAIRE_LIST_SUCCESS: `GET_${DataTypes.MSF_QUESTIONNAIRE}_LIST_SUCCESS`,
    GET_MSF_QUESTIONNAIRE_LIST_FAILURE: `GET_${DataTypes.MSF_QUESTIONNAIRE}_LIST_FAILURE`,
    GET_MSF_QUESTIONNAIRE_REQUEST: `GET_${DataTypes.MSF_QUESTIONNAIRE}_REQUEST`,
    GET_MSF_QUESTIONNAIRE_SUCCESS: `GET_${DataTypes.MSF_QUESTIONNAIRE}_SUCCESS`,
    GET_MSF_QUESTIONNAIRE_FAILURE: `GET_${DataTypes.MSF_QUESTIONNAIRE}_FAILURE`,
    UPDATE_MSF_QUESTIONNAIRE_REQUEST: `UPDATE_${DataTypes.MSF_QUESTIONNAIRE}_REQUEST`,
    UPDATE_MSF_QUESTIONNAIRE_SUCCESS: `UPDATE_${DataTypes.MSF_QUESTIONNAIRE}_SUCCESS`,
    UPDATE_MSF_QUESTIONNAIRE_FAILURE: `UPDATE_${DataTypes.MSF_QUESTIONNAIRE}_FAILURE`,
    GET_MSF_FACILITATORS_REQUEST: `GET_${DataTypes.MSF_FACILITATORS}_REQUEST`,
    GET_MSF_FACILITATORS_SUCCESS: `GET_${DataTypes.MSF_FACILITATORS}_SUCCESS`,
    GET_MSF_FACILITATORS_FAILURE: `GET_${DataTypes.MSF_FACILITATORS}_FAILURE`,
    GET_MSF_RECIPIENTS_REQUEST: `GET_${DataTypes.MSF_RECIPIENTS}_REQUEST`,
    GET_MSF_RECIPIENTS_SUCCESS: `GET_${DataTypes.MSF_RECIPIENTS}_SUCCESS`,
    GET_MSF_RECIPIENTS_FAILURE: `GET_${DataTypes.MSF_RECIPIENTS}_FAILURE`,

    GET_CMS_CONTENT_REQUEST: `GET_${DataTypes.CMS_CONTENT}_REQUEST`,
    GET_CMS_CONTENT_SUCCESS: `GET_${DataTypes.CMS_CONTENT}_SUCCESS`,
    GET_CMS_CONTENT_FAILURE: `GET_${DataTypes.CMS_CONTENT}_FAILURE`,

    GET_ACCOUNT_PROFILE: `GET_${DataTypes.ACCOUNT_PROFILE}`,
    UPDATE_ACCOUNT_PROFILE_REQUEST: `UPDATE_${DataTypes.ACCOUNT_PROFILE}_REQUEST`,
    UPDATE_ACCOUNT_PROFILE_SUCCESS: `UPDATE_${DataTypes.ACCOUNT_PROFILE}_SUCCESS`,
    UPDATE_ACCOUNT_PROFILE_FAILURE: `UPDATE_${DataTypes.ACCOUNT_PROFILE}_FAILURE`,
    UPDATE_ACCOUNT_SECURITY_REQUEST: `UPDATE_${DataTypes.ACCOUNT_SECURITY}_REQUEST`,
    UPDATE_ACCOUNT_SECURITY_SUCCESS: `UPDATE_${DataTypes.ACCOUNT_SECURITY}_SUCCESS`,
    UPDATE_ACCOUNT_SECURITY_FAILURE: `UPDATE_${DataTypes.ACCOUNT_SECURITY}_FAILURE`,
    SEND_ACCOUNT_PASSWORD_RESET_LINK_REQUEST: `UPDATE_${DataTypes.ACCOUNT_PASSWORD}_REQUEST`,
    SEND_ACCOUNT_PASSWORD_RESET_LINK_SUCCESS: `UPDATE_${DataTypes.ACCOUNT_PASSWORD}_SUCCESS`,
    SEND_ACCOUNT_PASSWORD_RESET_LINK_FAILURE: `UPDATE_${DataTypes.ACCOUNT_PASSWORD}_FAILURE`,
    GET_ACCOUNT_SUBSCRIPTIONS: `GET_${DataTypes.ACCOUNT_SUBSCRIPTIONS}`,

    GET_ACTIVITIES_REQUEST: `GET_${DataTypes.ACTIVITIES}_REQUEST`,
    GET_ACTIVITIES_SUCCESS: `GET_${DataTypes.ACTIVITIES}_SUCCESS`,
    GET_ACTIVITIES_FAILURE: `GET_${DataTypes.ACTIVITIES}_FAILURE`,
    GET_ACTIVITY_REQUEST: `GET_${DataTypes.ACTIVITY}_REQUEST`,
    GET_ACTIVITY_SUCCESS: `GET_${DataTypes.ACTIVITY}_SUCCESS`,
    GET_ACTIVITY_FAILURE: `GET_${DataTypes.ACTIVITY}_FAILURE`,
    ADD_ACTIVITY_REQUEST: `ADD_${DataTypes.ACTIVITY}_REQUEST`,
    ADD_ACTIVITY_SUCCESS: `ADD_${DataTypes.ACTIVITY}_SUCCESS`,
    ADD_ACTIVITY_FAILURE: `ADD_${DataTypes.ACTIVITY}_FAILURE`,
    UPDATE_ACTIVITY_REQUEST: `UPDATE_${DataTypes.ACTIVITY}_REQUEST`,
    UPDATE_ACTIVITY_SUCCESS: `UPDATE_${DataTypes.ACTIVITY}_SUCCESS`,
    UPDATE_ACTIVITY_FAILURE: `UPDATE_${DataTypes.ACTIVITY}_FAILURE`,
    DELETE_ACTIVITY_REQUEST: `DELETE_${DataTypes.ACTIVITY}_REQUEST`,
    DELETE_ACTIVITY_SUCCESS: `DELETE_${DataTypes.ACTIVITY}_SUCCESS`,
    DELETE_ACTIVITY_FAILURE: `DELETE_${DataTypes.ACTIVITY}_FAILURE`,
    GET_ACTIVITY_TYPES_REQUEST: `GET_${DataTypes.ACTIVITY}_TYPES_REQUEST`,
    GET_ACTIVITY_TYPES_SUCCESS: `GET_${DataTypes.ACTIVITY}_TYPES_SUCCESS`,
    GET_ACTIVITY_TYPES_FAILURE: `GET_${DataTypes.ACTIVITY}_TYPES_FAILURE`,

    GET_NOTES_REQUEST: `GET_${DataTypes.NOTES}_REQUEST`,
    GET_NOTES_SUCCESS: `GET_${DataTypes.NOTES}_SUCCESS`,
    GET_NOTES_FAILURE: `GET_${DataTypes.NOTES}_FAILURE`,
    GET_NOTE_REQUEST: `GET_${DataTypes.NOTE}_REQUEST`,
    GET_NOTE_SUCCESS: `GET_${DataTypes.NOTE}_SUCCESS`,
    GET_NOTE_FAILURE: `GET_${DataTypes.NOTE}_FAILURE`,
    ADD_NOTE_REQUEST: `ADD_${DataTypes.NOTE}_REQUEST`,
    ADD_NOTE_SUCCESS: `ADD_${DataTypes.NOTE}_SUCCESS`,
    ADD_NOTE_FAILURE: `ADD_${DataTypes.NOTE}_FAILURE`,
    UPDATE_NOTE_REQUEST: `UPDATE_${DataTypes.NOTE}_REQUEST`,
    UPDATE_NOTE_SUCCESS: `UPDATE_${DataTypes.NOTE}_SUCCESS`,
    UPDATE_NOTE_FAILURE: `UPDATE_${DataTypes.NOTE}_FAILURE`,
    DELETE_NOTE_REQUEST: `DELETE_${DataTypes.NOTE}_REQUEST`,
    DELETE_NOTE_SUCCESS: `DELETE_${DataTypes.NOTE}_SUCCESS`,
    DELETE_NOTE_FAILURE: `DELETE_${DataTypes.NOTE}_FAILURE`,

    GET_PDPS_REQUEST: `GET_${DataTypes.PDPS}_REQUEST`,
    GET_PDPS_SUCCESS: `GET_${DataTypes.PDPS}_SUCCESS`,
    GET_PDPS_FAILURE: `GET_${DataTypes.PDPS}_FAILURE`,
    GET_PDP_REQUEST: `GET_${DataTypes.PDP}_REQUEST`,
    GET_PDP_SUCCESS: `GET_${DataTypes.PDP}_SUCCESS`,
    GET_PDP_FAILURE: `GET_${DataTypes.PDP}_FAILURE`,
    UPDATE_PDP_REQUEST: `UPDATE_${DataTypes.PDP}_REQUEST`,
    UPDATE_PDP_SUCCESS: `UPDATE_${DataTypes.PDP}_SUCCESS`,
    UPDATE_PDP_FAILURE: `UPDATE_${DataTypes.PDP}_FAILURE`,
    DELETE_PDP_REQUEST: `DELETE_${DataTypes.PDP}_REQUEST`,
    DELETE_PDP_SUCCESS: `DELETE_${DataTypes.PDP}_SUCCESS`,
    DELETE_PDP_FAILURE: `DELETE_${DataTypes.PDP}_FAILURE`,

    GET_QUALIFICATIONS_REQUEST: `GET_${DataTypes.QUALIFICATIONS}_REQUEST`,
    GET_QUALIFICATIONS_SUCCESS: `GET_${DataTypes.QUALIFICATIONS}_SUCCESS`,
    GET_QUALIFICATIONS_FAILURE: `GET_${DataTypes.QUALIFICATIONS}_FAILURE`,
    GET_QUALIFICATION_REQUEST: `GET_${DataTypes.QUALIFICATION}_REQUEST`,
    GET_QUALIFICATION_SUCCESS: `GET_${DataTypes.QUALIFICATION}_SUCCESS`,
    GET_QUALIFICATION_FAILURE: `GET_${DataTypes.QUALIFICATION}_FAILURE`,
    ADD_QUALIFICATION_REQUEST: `ADD_${DataTypes.QUALIFICATION}_REQUEST`,
    ADD_QUALIFICATION_SUCCESS: `ADD_${DataTypes.QUALIFICATION}_SUCCESS`,
    ADD_QUALIFICATION_FAILURE: `ADD_${DataTypes.QUALIFICATION}_FAILURE`,
    UPDATE_QUALIFICATION_REQUEST: `UPDATE_${DataTypes.QUALIFICATION}_REQUEST`,
    UPDATE_QUALIFICATION_SUCCESS: `UPDATE_${DataTypes.QUALIFICATION}_SUCCESS`,
    UPDATE_QUALIFICATION_FAILURE: `UPDATE_${DataTypes.QUALIFICATION}_FAILURE`,
    DELETE_QUALIFICATION_REQUEST: `DELETE_${DataTypes.QUALIFICATION}_REQUEST`,
    DELETE_QUALIFICATION_SUCCESS: `DELETE_${DataTypes.QUALIFICATION}_SUCCESS`,
    DELETE_QUALIFICATION_FAILURE: `DELETE_${DataTypes.QUALIFICATION}_FAILURE`,

    GET_RESOURCES_REQUEST: `GET_${DataTypes.RESOURCES}_REQUEST`,
    GET_RESOURCES_SUCCESS: `GET_${DataTypes.RESOURCES}_SUCCESS`,
    GET_RESOURCES_FAILURE: `GET_${DataTypes.RESOURCES}_FAILURE`,
    GET_RESOURCE_DETAILS_REQUEST: `GET_${DataTypes.RESOURCE}_REQUEST`,
    GET_RESOURCE_DETAILS_SUCCESS: `GET_${DataTypes.RESOURCE}_SUCCESS`,
    GET_RESOURCE_DETAILS_FAILURE: `GET_${DataTypes.RESOURCE}_FAILURE`,
    ADD_RESOURCE_REQUEST: `ADD_${DataTypes.RESOURCE}_REQUEST`,
    ADD_RESOURCE_SUCCESS: `ADD_${DataTypes.RESOURCE}_SUCCESS`,
    ADD_RESOURCE_FAILURE: `ADD_${DataTypes.RESOURCE}_FAILURE`,
    UPDATE_RESOURCE_REQUEST: `UPDATE_${DataTypes.RESOURCE}_REQUEST`,
    UPDATE_RESOURCE_SUCCESS: `UPDATE_${DataTypes.RESOURCE}_SUCCESS`,
    UPDATE_RESOURCE_FAILURE: `UPDATE_${DataTypes.RESOURCE}_FAILURE`,
    DELETE_RESOURCE_REQUEST: `DELETE_${DataTypes.RESOURCE}_REQUEST`,
    DELETE_RESOURCE_SUCCESS: `DELETE_${DataTypes.RESOURCE}_SUCCESS`,
    DELETE_RESOURCE_FAILURE: `DELETE_${DataTypes.RESOURCE}_FAILURE`,

    GET_CATEGORIES_REQUEST: `GET_${DataTypes.CATEGORIES}_REQUEST`,
    GET_CATEGORIES_SUCCESS: `GET_${DataTypes.CATEGORIES}_SUCCESS`,
    GET_CATEGORIES_FAILURE: `GET_${DataTypes.CATEGORIES}_FAILURE`,

    GET_CONTACTS_REQUEST: `GET_${DataTypes.CONTACTS}_REQUEST`,
    GET_CONTACTS_SUCCESS: `GET_${DataTypes.CONTACTS}_SUCCESS`,
    GET_CONTACTS_FAILURE: `GET_${DataTypes.CONTACTS}_FAILURE`,

    GET_MESSAGES_REQUEST: `GET_${DataTypes.MESSAGES}_REQUEST`,
    GET_MESSAGES_SUCCESS: `GET_${DataTypes.MESSAGES}_SUCCESS`,
    GET_MESSAGES_FAILURE: `GET_${DataTypes.MESSAGES}_FAILURE`,
    GET_MESSAGE_REQUEST: `GET_${DataTypes.MESSAGE}_REQUEST`,
    GET_MESSAGE_SUCCESS: `GET_${DataTypes.MESSAGE}_SUCCESS`,
    GET_MESSAGE_FAILURE: `GET_${DataTypes.MESSAGE}_FAILURE`,
    ADD_MESSAGE_REQUEST: `ADD_${DataTypes.MESSAGE}_REQUEST`,
    ADD_MESSAGE_SUCCESS: `ADD_${DataTypes.MESSAGE}_SUCCESS`,
    ADD_MESSAGE_FAILURE: `ADD_${DataTypes.MESSAGE}_FAILURE`,
    UPDATE_MESSAGE_REQUEST: `UPDATE_${DataTypes.MESSAGE}_REQUEST`,
    UPDATE_MESSAGE_SUCCESS: `UPDATE_${DataTypes.MESSAGE}_SUCCESS`,
    UPDATE_MESSAGE_FAILURE: `UPDATE_${DataTypes.MESSAGE}_FAILURE`,
    DELETE_MESSAGE_REQUEST: `DELETE_${DataTypes.MESSAGE}_REQUEST`,
    DELETE_MESSAGE_SUCCESS: `DELETE_${DataTypes.MESSAGE}_SUCCESS`,
    DELETE_MESSAGE_FAILURE: `DELETE_${DataTypes.MESSAGE}_FAILURE`,

    GET_NOTIFICATIONS_REQUEST: `GET_${DataTypes.NOTIFICATIONS}_REQUEST`,
    GET_NOTIFICATIONS_SUCCESS: `GET_${DataTypes.NOTIFICATIONS}_SUCCESS`,
    GET_NOTIFICATIONS_FAILURE: `GET_${DataTypes.NOTIFICATIONS}_FAILURE`,
    GET_NOTIFICATION_REQUEST: `GET_${DataTypes.NOTIFICATION}_REQUEST`,
    GET_NOTIFICATION_SUCCESS: `GET_${DataTypes.NOTIFICATION}_SUCCESS`,
    GET_NOTIFICATION_FAILURE: `GET_${DataTypes.NOTIFICATION}_FAILURE`,

    GET_TASKS_REQUEST: `GET_${DataTypes.TASKS}_REQUEST`,
    GET_TASKS_SUCCESS: `GET_${DataTypes.TASKS}_SUCCESS`,
    GET_TASKS_FAILURE: `GET_${DataTypes.TASKS}_FAILURE`,

    GET_TERMS_REQUEST: `GET_${DataTypes.TERMS}_REQUEST`,
    GET_TERMS_SUCCESS: `GET_${DataTypes.TERMS}_SUCCESS`,
    GET_TERMS_FAILURE: `GET_${DataTypes.TERMS}_FAILURE`,
    UPDATE_TERM_REQUEST: `UPDATE_${DataTypes.TERM}_REQUEST`,
    UPDATE_TERM_SUCCESS: `UPDATE_${DataTypes.TERM}_SUCCESS`,
    UPDATE_TERM_FAILURE: `UPDATE_${DataTypes.TERM}_FAILURE`,

    GET_TMS_ACCOMPLISHMENTS_REQUEST: `GET_${DataTypes.TMS_ACCOMPLISHMENTS}_REQUEST`,
    GET_TMS_ACCOMPLISHMENTS_SUCCESS: `GET_${DataTypes.TMS_ACCOMPLISHMENTS}_SUCCESS`,
    GET_TMS_ACCOMPLISHMENTS_FAILURE: `GET_${DataTypes.TMS_ACCOMPLISHMENTS}_FAILURE`,
    GET_TMS_COURSES_REQUEST: `GET_${DataTypes.TMS_COURSES}_REQUEST`,
    GET_TMS_COURSES_SUCCESS: `GET_${DataTypes.TMS_COURSES}_SUCCESS`,
    GET_TMS_COURSES_FAILURE: `GET_${DataTypes.TMS_COURSES}_FAILURE`,
    GET_TMS_COURSE_DETAILS_REQUEST: `GET_${DataTypes.TMS_COURSE}_REQUEST`,
    GET_TMS_COURSE_DETAILS_SUCCESS: `GET_${DataTypes.TMS_COURSE}_SUCCESS`,
    GET_TMS_COURSE_DETAILS_FAILURE: `GET_${DataTypes.TMS_COURSE}_FAILURE`,
    GET_TMS_CATEGORY_DETAILS_REQUEST: `GET_${DataTypes.TMS_CATEGORY}_REQUEST`,
    GET_TMS_CATEGORY_DETAILS_SUCCESS: `GET_${DataTypes.TMS_CATEGORY}_SUCCESS`,
    GET_TMS_CATEGORY_DETAILS_FAILURE: `GET_${DataTypes.TMS_CATEGORY}_FAILURE`,
    ADD_TMS_ENROLMENT_REQUEST: `ADD_${DataTypes.TMS_ENROLMENT}_REQUEST`,
    ADD_TMS_ENROLMENT_SUCCESS: `ADD_${DataTypes.TMS_ENROLMENT}_SUCCESS`,
    ADD_TMS_ENROLMENT_FAILURE: `ADD_${DataTypes.TMS_ENROLMENT}_FAILURE`,
    DELETE_TMS_ENROLMENT_REQUEST: `DELETE_${DataTypes.TMS_ENROLMENT}_REQUEST`,
    DELETE_TMS_ENROLMENT_SUCCESS: `DELETE_${DataTypes.TMS_ENROLMENT}_SUCCESS`,
    DELETE_TMS_ENROLMENT_FAILURE: `DELETE_${DataTypes.TMS_ENROLMENT}_FAILURE`,
    UPDATE_TMS_ENROLMENT_REQUEST: `UPDATE_${DataTypes.TMS_ENROLMENT}_REQUEST`,
    UPDATE_TMS_ENROLMENT_SUCCESS: `UPDATE_${DataTypes.TMS_ENROLMENT}_SUCCESS`,
    UPDATE_TMS_ENROLMENT_FAILURE: `UPDATE_${DataTypes.TMS_ENROLMENT}_FAILURE`,
    RETAKE_TMS_MODULE_REQUEST: `RETAKE_${DataTypes.TMS_MODULE}_REQUEST`,
    RETAKE_TMS_MODULE_SUCCESS: `RETAKE_${DataTypes.TMS_MODULE}_SUCCESS`,
    RETAKE_TMS_MODULE_FAILURE: `RETAKE_${DataTypes.TMS_MODULE}_FAILURE`,
    UPDATE_TMS_MODULE_ENROLMENT_REQUEST: `UPDATE_${DataTypes.TMS_MODULE_ENROLMENT}_REQUEST`,
    UPDATE_TMS_MODULE_ENROLMENT_SUCCESS: `UPDATE_${DataTypes.TMS_MODULE_ENROLMENT}_SUCCESS`,
    UPDATE_TMS_MODULE_ENROLMENT_FAILURE: `UPDATE_${DataTypes.TMS_MODULE_ENROLMENT}_FAILURE`,
    GET_TMS_LAUNCH_URL_REQUEST: `GET_${DataTypes.TMS_LAUNCH_URL}_REQUEST`,
    GET_TMS_LAUNCH_URL_SUCCESS: `GET_${DataTypes.TMS_LAUNCH_URL}_SUCCESS`,
    GET_TMS_LAUNCH_URL_FAILURE: `GET_${DataTypes.TMS_LAUNCH_URL}_FAILURE`,
    GET_TMS_EVENT_LIST_REQUEST: `GET_${DataTypes.TMS_EVENTS}_LIST_REQUEST`,
    GET_TMS_EVENT_LIST_SUCCESS: `GET_${DataTypes.TMS_EVENTS}_LIST_SUCCESS`,
    GET_TMS_EVENT_LIST_FAILURE: `GET_${DataTypes.TMS_EVENTS}_LIST_FAILURE`,
    GET_TMS_EVENT_REQUEST: `GET_${DataTypes.TMS_EVENT}_REQUEST`,
    GET_TMS_EVENT_SUCCESS: `GET_${DataTypes.TMS_EVENT}_SUCCESS`,
    GET_TMS_EVENT_FAILURE: `GET_${DataTypes.TMS_EVENT}_FAILURE`,
    GET_TMS_EVENT_BOOKING_LIST_REQUEST: `GET_${DataTypes.TMS_EVENT_BOOKING}_LIST_REQUEST`,
    GET_TMS_EVENT_BOOKING_LIST_SUCCESS: `GET_${DataTypes.TMS_EVENT_BOOKING}_LIST_SUCCESS`,
    GET_TMS_EVENT_BOOKING_LIST_FAILURE: `GET_${DataTypes.TMS_EVENT_BOOKING}_LIST_FAILURE`,
    ADD_TMS_EVENT_BOOKING_REQUEST: `ADD_${DataTypes.TMS_EVENT_BOOKING}_REQUEST`,
    ADD_TMS_EVENT_BOOKING_SUCCESS: `ADD_${DataTypes.TMS_EVENT_BOOKING}_SUCCESS`,
    ADD_TMS_EVENT_BOOKING_FAILURE: `ADD_${DataTypes.TMS_EVENT_BOOKING}_FAILURE`,
    DELETE_TMS_EVENT_BOOKING_REQUEST: `DELETE_${DataTypes.TMS_EVENT_BOOKING}_REQUEST`,
    DELETE_TMS_EVENT_BOOKING_SUCCESS: `DELETE_${DataTypes.TMS_EVENT_BOOKING}_SUCCESS`,
    DELETE_TMS_EVENT_BOOKING_FAILURE: `DELETE_${DataTypes.TMS_EVENT_BOOKING}_FAILURE`,
    UPDATE_TMS_EVENT_BOOKING_REQUEST: `UPDATE_${DataTypes.TMS_EVENT_BOOKING}_REQUEST`,
    UPDATE_TMS_EVENT_BOOKING_SUCCESS: `UPDATE_${DataTypes.TMS_EVENT_BOOKING}_SUCCESS`,
    UPDATE_TMS_EVENT_BOOKING_FAILURE: `UPDATE_${DataTypes.TMS_EVENT_BOOKING}_FAILURE`,

    GET_TMS_LIBRARY_REQUEST: `GET_${DataTypes.TMS_LIBRARY}_REQUEST`,
    GET_TMS_LIBRARY_SUCCESS: `GET_${DataTypes.TMS_LIBRARY}_SUCCESS`,
    GET_TMS_LIBRARY_FAILURE: `GET_${DataTypes.TMS_LIBRARY}_FAILURE`,

    GET_RS_ROSTER_LIST_REQUEST: `GET_${DataTypes.RS_ROSTER}_LIST_REQUEST`,
    GET_RS_ROSTER_LIST_SUCCESS: `GET_${DataTypes.RS_ROSTER}_LIST_SUCCESS`,
    GET_RS_ROSTER_LIST_FAILURE: `GET_${DataTypes.RS_ROSTER}_LIST_FAILURE`,
    GET_RS_ROSTER_REQUEST: `GET_${DataTypes.RS_ROSTER}_REQUEST`,
    GET_RS_ROSTER_SUCCESS: `GET_${DataTypes.RS_ROSTER}_SUCCESS`,
    GET_RS_ROSTER_FAILURE: `GET_${DataTypes.RS_ROSTER}_FAILURE`,

    CLEAR_ERRORS: "CLEAR_ERRORS",
    CLEAR_SUCCESS_MESSAGE: "CLEAR_SUCCESS_MESSAGE",
    LOGOUT: "LOGOUT",
    LOGIN_FAILURE: "LOGIN_FAILURE"
};

export const Ethnicities = [
    { code: 'W1', description: "British" },
    { code: 'W2', description: "Irish" },
    { code: 'W3', description: "Gypsy or Irish Traveller" },
    { code: 'W9', description: "Any other White background" },
    { code: 'M1', description: "White and Black Caribbean" },
    { code: 'M2', description: "White and Black African" },
    { code: 'M3', description: "White and Asian" },
    { code: 'M9', description: "Any other Mixed or Multiple background" },
    { code: 'A1', description: "Indian" },
    { code: 'A2', description: "Pakistani" },
    { code: 'A3', description: "Bangladeshi" },
    { code: 'A4', description: "Chinese" },
    { code: 'A9', description: "Any other Asian background" },
    { code: 'B1', description: "Caribbean" },
    { code: 'B2', description: "African" },
    { code: 'B9', description: "Any other Black, Black British or Caribbean background" },
    { code: 'O2', description: "Arab" },
    { code: 'O9', description: "Any other ethnic group" },
    { code: 'NS', description: "Not Stated" }
];

export const DaysOfWeek = [
    {name: 'Sun', value: 0},
    {name: 'Mon', value: 1},
    {name: 'Tue', value: 2},
    {name: 'Wed', value: 3},
    {name: 'Thu', value: 4},
    {name: 'Fri', value: 5},
    {name: 'Sat', value: 6}
];
